import React, { useState } from "react";
import "./Header.css";
import logo from "../../assets/logo.png";
import Bars from "../../assets/bars.png";
import {Link} from "react-scroll";
const Header = () => {
  const mobile = window.innerWidth <= 780 ? true : false;
  const [menuOpened, setMenuOpened] = useState(false);
  return (
    <div className="header">
      <img className="logo" src={logo} alt="" />
      {menuOpened === false && mobile === true ? (
        <div
          onClick={() => setMenuOpened(true)}
          style={{
            backgroundColor: "var(--appColor)",
            padding: "0.5rem",
            borderRadius: "5px",
          }}
        >
          <img
            style={{ width: "1.5rem", height: "1.5rem" }}
            src={Bars}
            alt=""
          />
        </div>
      ) : (
        <ul className="header-menu">
          <li>
            <Link
            onClick={() => setMenuOpened(false)}
            to = 'hero'
            activeClass="active"
            span={true}
            smooth={true}
            >
            Home</Link>
          </li>
          <li >
            <Link
              onClick={() => setMenuOpened(false)}
              to = 'programs-header'
              span={true}
              smooth={true}
            > Programs</Link></li>
          <li >
            <Link
             onClick={() => setMenuOpened(false)}
             to = 'Reasons'
             span={true}
             smooth={true}
            >Why us</Link>
            </li>
          <li >
            <Link
            onClick={() => setMenuOpened(false)}
            to = 'plans-container'
            span={true}
            smooth={true}
            >Plans</Link>
            </li>
          <li>
            <Link
              onClick={() => setMenuOpened(false)}
              to="Testimonial"
              span={true}
              smooth={true}
            >
              Testimonials
            </Link>
          </li>
        </ul>
      )}
      ;
    </div>
  );
};

export default Header;
